import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'
import { Product, useStore } from 'zens-store'
import { Table, TableCol, TableProps } from 'zens-storybook'

import Failed from './failed'
import Success from './success'
import Date from './date'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
})

interface Props extends Omit<TableProps, 'rows' | 'cols' | 'locale'> {
  product?: Product
}

const LoggingSync = (props: Props) => {
  const { product, style, ...otherProps } = props
  const { t } = useTranslation()
  const { i18n } = useStore()
  const { syncFailed, settingChangedAt, acknowledgedAt } = product || {}

  const renderSync = () => {
    return syncFailed ? <Failed /> : <Success />
  }

  const renderDate = (_: any, key: string) => {
    const date = product?.[key as keyof Product]
    if (!date) return undefined
    return <Date date={date} />
  }

  const rows = [
    {
      data: { setting: t('Schedule settings'), syncFailed, settingChangedAt, acknowledgedAt },
    },
  ]
  const cols: TableCol<Product>[] = [
    {
      key: 'setting',
      title: t('Setting'),
    },
    {
      key: 'syncFailed',
      title: t('Sync'),
      render: renderSync,
    },
    {
      key: 'settingChangedAt',
      title: t('Last changed'),
      render: renderDate,
    },
    {
      key: 'acknowledgedAt',
      title: t('Last acknowledged'),
      render: renderDate,
    },
  ]
  return <Table style={[styles.container, style]} {...otherProps} rows={rows} cols={cols} locale={i18n.language} />
}

export default LoggingSync
